import { Path, SVG } from '@wordpress/primitives';

export default (
	<SVG xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" style={ { fill: "none" } } stroke="currentColor" strokeWidth="1.5">
		<Path d="M4.5 17.5V17.2027L5.62821 13.9324M5.62821 13.9324L8.19231 6.5H8.80769L11.3718 13.9324L12.5 17.2027V17.5M11.3718 13.9324H5.62821" />
		<Path d="M19.5 13.8097V11.0001M19.5 13.8097C19.5 15.4844 18.1304 16.9603 16.5576 16.9603C14.9848 16.9603 14.5586 15.9414 14.4922 15.4844C14.4258 15.0273 14.4545 14.2521 15.1207 13.6609C15.7868 13.0696 16.6425 12.9616 17.4007 12.8201C18.1589 12.6786 19.5 12.2501 19.5 11.0001M19.5 13.8097V17.5M19.5 11.0001C19.5 9.75009 18.4545 9.25 17.3189 9.25C15.3174 9.25 14.5 11.0001 14.5 11.0001" />
	</SVG>
);
